<div id="managePopUp" class="militaryTechErr">
  <div class="modal-header justify-content-start">
    <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-15 errorIcon" alt="">
    <h4 class="modal-title mt-0" id="modal-basic-title">{{authoringContentData?.lineIdentifierAuthoring?.errorModalHeading}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
     <span> <img src="/assets/tfb-acctmgmt/images/icons/close-icon.png" alt=""></span>
    </button>
  </div> 
  <div class="modal-body">
    <div class="row m-0">
      <div class="addGroup-label">
        <p class="errBodyTxt">{{authoringContentData?.lineIdentifierAuthoring?.errorModalTxt}}</p>
      </div>
    </div>
  </div>
</div>